import { registerCatalog } from "@/lib/i18n";

registerCatalog("zh-Hans", {
  "nav.home": "我的 Memos",
  "nav.explore": "探索",
  "nav.attachments": "附件",
  "nav.chatImport": "聊天归档",
  "nav.inbox": "收件箱",
  "nav.settings": "设置",
  "nav.about": "关于",
  "nav.signin": "登录",
  "nav.signout": "退出登录",
  "nav.archived": "已归档",
  "nav.shortcuts": "快捷筛选",
  "nav.profile": "个人资料",
  "nav.compose": "记录",

  "action.save": "保存",
  "action.cancel": "取消",
  "action.delete": "删除",
  "action.edit": "编辑",
  "action.create": "创建",
  "action.confirm": "确认",
  "action.retry": "重试",
  "action.close": "关闭",
  "action.copy": "复制",
  "action.copied": "已复制",
  "action.share": "分享",
  "action.archive": "归档",
  "action.restore": "恢复",
  "action.pin": "置顶",
  "action.unpin": "取消置顶",
  "action.loadMore": "加载更多",
  "action.refresh": "刷新",
  "action.search": "搜索",
  "action.back": "返回",
  "action.submit": "提交",
  "action.upload": "上传",
  "action.download": "下载",
  "action.reveal": "显示",

  "auth.signIn.title": "登录 {title}",
  "auth.username": "用户名",
  "auth.password": "密码",
  "auth.signIn.submit": "登录",
  "auth.signIn.sso": "使用 {provider} 登录",
  "auth.signIn.noAccount": "还没有账号？",
  "auth.signIn.createOne": "立即创建",
  "auth.signIn.adminFallback": "管理员登录",
  "auth.signup.title": "创建账号",
  "auth.signup.firstAdmin.title": "初始化实例",
  "auth.signup.firstAdmin.description":
    "创建第一个管理员账号以完成 Memos 实例的初始化。",
  "auth.signup.submit": "创建账号",
  "auth.signup.confirmPassword": "确认密码",
  "auth.signup.passwordMismatch": "两次输入的密码不一致",
  "auth.error.generic": "登录失败，请检查凭据后重试。",

  "editor.placeholder": "此刻的想法……",
  "editor.mode.post": "Memo",
  "editor.mode.article": "文章",
  "editor.visibility.private": "仅自己",
  "editor.visibility.protected": "登录用户",
  "editor.visibility.public": "公开",
  "editor.submit": "保存 memo",
  "editor.editing": "编辑 memo",
  "editor.addLocation": "添加位置",
  "editor.addAttachment": "添加附件",
  "editor.addRelation": "添加关联",
  "editor.setTime": "设置时间",
  "editor.discard.confirm": "确定丢弃此草稿吗？此操作不可撤销。",
  "editor.contentTooLong": "内容超出 {limit} 字节限制。",

  "feed.empty.title": "还没有 memo",
  "feed.empty.body": "在上方写下第一条 memo 开始吧。",
  "feed.noResults": "没有符合当前筛选条件的 memo。",
  "feed.loadError": "加载 memo 失败。",
  "feed.offline": "当前处于离线状态，联网后才能加载新 memo。",
  "feed.forbidden": "你没有权限查看这些 memo。",
  "feed.filter.clear": "清除筛选",
  "feed.filter.clearAll": "全部清除",

  "agent.filter.all": "全部",
  "agent.filter.ready": "Ready",
  "agent.filter.empty": "暂无已处理完成的 memo",
  "agent.action.run": "运行",
  "agent.action.rerun": "重新运行",
  "agent.action.approve": "批准",
  "agent.panel.title": "Agent",
  "agent.panel.description": "后台处理状态与提取结果。",
  "agent.panel.empty": "暂时还没有可展示的 Agent 产物。",
  "agent.forbidden": "你没有权限访问该 Agent 状态。",
  "agent.unavailable": "当前无法获取 Agent 状态。",
  "agent.toast.runQueued": "已加入 Agent 处理队列",
  "agent.toast.rerunQueued": "已加入 Agent 重跑队列",
  "agent.toast.approved": "已提交 Agent 批准",
  "agent.field.skill": "技能",
  "agent.field.pipeline": "流水线",
  "agent.field.plan": "计划",
  "agent.field.mode": "模式",
  "agent.field.action": "动作",
  "agent.field.reason": "原因",
  "agent.field.confidence": "置信度",
  "agent.field.routeStatus": "路由状态",
  "agent.artifact.summary": "摘要",
  "agent.artifact.keyPoints": "要点",
  "agent.artifact.suggestedTags": "建议标签",
  "agent.artifact.actionItems": "行动项",
  "agent.status.unprocessed": "未处理",
  "agent.status.queued": "排队中",
  "agent.status.processing": "处理中",
  "agent.status.ready": "已就绪",
  "agent.status.skipped": "已跳过",
  "agent.status.needs_review": "待复核",
  "agent.status.failed": "失败",
  "agent.status.stale": "已过期",

  "memo.delete.confirm": "确定删除此 memo 吗？此操作不可撤销。",
  "memo.comments": "评论",
  "memo.comments.empty": "还没有评论。",
  "memo.comment.placeholder": "写下评论……",
  "memo.copyLink": "复制链接",
  "memo.copyContent": "复制内容",
  "memo.shareImage": "生成分享图片",

  "article.label": "文章",
  "article.title": "标题",
  "article.titlePlaceholder": "为文章写一个清晰的标题",
  "article.bodyPlaceholder": "使用 Markdown 撰写正文……",
  "article.untitled": "未命名文章",
  "article.read": "阅读全文",
  "article.readingTime": "阅读约 {minutes} 分钟",

  "chatImport.title": "Codex 聊天归档",
  "chatImport.addFile": "添加 JSONL",
  "chatImport.chooseFile": "选择 JSONL",
  "chatImport.empty": "拖入 Codex JSONL 文件",
  "chatImport.emptyHint": "文件会先在浏览器本地解析。",
  "chatImport.sessionCount": "共 {count} 个会话",
  "chatImport.imported": "已导入 {count} 个会话",
  "chatImport.stats": "{turns} 轮 · {tools} 次工具调用",
  "chatImport.skipped": "已跳过 {count} 行无效记录",
  "chatImport.mode": "文章详细程度",
  "chatImport.mode.review": "精简复盘",
  "chatImport.mode.conversation": "完整对话",
  "chatImport.mode.full": "包含工具",
  "chatImport.visibility": "可见性",
  "chatImport.attachSource": "附带原始 JSONL",
  "chatImport.sourceWarning":
    "文章正文会自动脱敏；原始 JSONL 附件不会修改，并跟随文章可见性。",
  "chatImport.sourceTooLarge":
    "原始文件大小为 {size}，超过 {limit} 的附件上限，因此不会上传；文章仍可正常发布。",
  "chatImport.preview": "预览",
  "chatImport.markdown": "编辑 Markdown",
  "chatImport.publish": "发布文章",
  "chatImport.published": "文章已发布",
  "chatImport.error.fileType": "请选择一个或多个 .jsonl 文件。",
  "chatImport.error.parse": "无法解析这个 JSONL 文件。",
  "chatImport.error.publish": "文章发布失败。",
  "chatImport.error.title": "第一个非空内容必须是 H1 标题。",
  "chatImport.error.tooLong": "请选择更精简的模式，或编辑 Markdown。",

  "settings.myAccount": "我的账号",
  "settings.accessToken": "访问令牌",
  "settings.preference": "偏好设置",
  "settings.webhook": "Webhook",
  "settings.tags": "标签",
  "settings.member": "成员",
  "settings.system": "系统",
  "settings.memo": "Memo",
  "settings.storage": "存储",
  "settings.notification": "通知",
  "settings.sso": "SSO",
  "settings.resourceStats": "资源统计",
  "settings.theme": "主题",
  "settings.theme.system": "跟随系统",
  "settings.theme.light": "亮色",
  "settings.theme.dark": "暗色",
  "settings.theme.paper": "Paper",
  "settings.language": "语言",
  "settings.defaultVisibility": "默认 memo 可见性",

  "error.403.title": "无权访问",
  "error.403.body": "你没有权限查看此页面。",
  "error.404.title": "未找到",
  "error.404.body": "你要找的页面或资源不存在，或链接已失效。",
  "error.generic": "出错了。",
  "error.network": "网络错误，请检查连接后重试。",
  "error.chunk": "检测到新版本，请刷新以更新。",
  "state.loading": "加载中……",
  "state.empty": "这里还没有内容。",

  "about.version": "版本",
  "about.commit": "Commit",
  "about.license": "许可证",
  "about.demo": "演示实例",
  "about.links": "相关链接",
});
